import { Skeleton } from "components/ui/skeleton";
import { cn } from "utils/cn";

const CARD_COUNT = 4;
const FILTER_FIELD_COUNT = 5;
const bone = "bg-border";

const JobCard = () => (
    <article className="rounded-xl border border-border bg-card p-6">
        <div className="mb-4 flex items-start gap-4">
            <Skeleton className={cn("size-16 shrink-0 rounded-xl", bone)} />
            <div className="flex min-w-0 flex-1 flex-col gap-2">
                <Skeleton className={cn("h-6 w-4/5", bone)} />
                <Skeleton className={cn("h-4 w-2/5", bone)} />
                <div className="flex flex-wrap gap-3">
                    <Skeleton className={cn("h-4 w-24", bone)} />
                    <Skeleton className={cn("h-4 w-20", bone)} />
                    <Skeleton className={cn("h-4 w-28", bone)} />
                </div>
            </div>
        </div>
        <div className="mb-4 flex flex-wrap gap-2">
            <Skeleton className={cn("h-6 w-16 rounded-full", bone)} />
            <Skeleton className={cn("h-6 w-24 rounded-full", bone)} />
            <Skeleton className={cn("h-6 w-14 rounded-full", bone)} />
        </div>
        <div className="flex items-center justify-between border-t border-border pt-4">
            <Skeleton className={cn("h-6 w-32", bone)} />
            <div className="flex items-center gap-3">
                <Skeleton className={cn("h-4 w-20", bone)} />
                <Skeleton className={cn("size-4 rounded-sm", bone)} />
            </div>
        </div>
    </article>
);

const JobsSkeleton = () => (
    <div role="status" aria-busy="true" data-testid="jobs-skeleton" className="min-h-screen bg-gray-50">
        <span className="sr-only">Loading…</span>
        <div aria-hidden="true" className="mx-auto max-w-[1280px] px-4 py-4 sm:px-[15px] sm:py-6">
            <Skeleton className={cn("mb-6 h-10 w-56 rounded-md", bone)} />
            <Skeleton className={cn("mb-4 h-4 w-40", bone)} />
            <Skeleton className={cn("mb-4 h-10 w-36 rounded-lg md:hidden", bone)} />
            <div className="flex flex-col gap-6 md:flex-row">
                <aside className="hidden w-72 shrink-0 md:block">
                    <div className="rounded-lg border border-border bg-card p-6">
                        <Skeleton className={cn("mb-6 h-6 w-24", bone)} />
                        <div className="flex flex-col gap-4">
                            {Array.from({ length: FILTER_FIELD_COUNT }, (_, index) => (
                                <Skeleton key={index} className={cn("h-10 w-full rounded-md", bone)} />
                            ))}
                            <Skeleton className={cn("h-4 w-32", bone)} />
                            <Skeleton className={cn("h-4 w-40", bone)} />
                        </div>
                    </div>
                </aside>
                <div className="grid flex-1 grid-cols-1 gap-6 md:grid-cols-2">
                    {Array.from({ length: CARD_COUNT }, (_, index) => (
                        <JobCard key={index} />
                    ))}
                </div>
            </div>
        </div>
    </div>
);

export default JobsSkeleton;
